import { defineCopy } from './index';

/** Install gate copy (pwa.md section 1, ux.md voice guide). iOS 26 menu names as of 2026-11. */
export const gateCopy = defineCopy('gate', {
  title: 'Install first, ball later.',
  body: 'TTS Basketball lives on your home screen. Add it, then open it from there. Takes about 20 seconds.',
  codeLabel: 'Your crew code',
  codeNote: "Copy it now. You'll paste it once the app is open.",
  copy: 'Copy code',
  copied: 'Copied. Now install.',
  copyFailed: "Couldn't copy. Write it down, it's short.",
  installButton: 'Install TTS Basketball',
  installedAndroid: 'Installed. Chrome keeps you here, so open it from your home screen.',
  installedDesktop: 'Installed. The app opens in its own window.',
  installDismissed: 'No problem. The button stays here when you are ready.',
  alreadyHave: 'You already have it. Open TTS Basketball from your home screen.',
  steps: 'How to install',
  platforms: {
    'ios-safari': [
      'Tap the ••• button next to the address bar (bottom right, or top if you moved the bar up).',
      'Tap Share, then Add to Home Screen. Not there? Tap View More.',
      'Leave Open as Web App on, then tap Add.',
      'Close Safari and open TTS Basketball from your home screen.',
    ],
    'ios-other': [
      'Tap the Share button in the address bar or the menu.',
      'Tap Add to Home Screen. Not there? Open this page in Safari and try again.',
      'Leave Open as Web App on, then tap Add.',
      'Open TTS Basketball from your home screen.',
    ],
    'android-chrome': [
      'Tap the ⋮ menu at the top right.',
      'Tap Install app (or Add to home screen, then Install).',
      'Open TTS Basketball from your home screen.',
    ],
    'android-samsung': [
      'Tap the ≡ menu at the bottom.',
      'Tap Add page to, then Home screen.',
      'Open TTS Basketball from your home screen.',
    ],
    'android-other': [
      "Open this page in Chrome. Other browsers make a plain shortcut that won't work.",
      'In Chrome, tap ⋮ then Install app.',
      'Open TTS Basketball from your home screen.',
    ],
    'desktop-chromium': [
      'Click the install icon at the right end of the address bar. No icon? Open the ⋮ menu and pick Install TTS Basketball.',
      'Click Install in the little box that opens.',
      'The app opens in its own window.',
    ],
    'desktop-safari': ['Open the File menu and pick Add to Dock.', 'Open TTS Basketball from the Dock.'],
    'desktop-firefox': ["Firefox can't install web apps. Open this page in Chrome or Edge."],
    'desktop-other': ['Open this page in Chrome, Edge or Safari, then install it from the menu.'],
  },
  inAppBrowser:
    "No Add to Home Screen? You're inside another app. Tap ••• or the compass icon and pick Open in Safari or Open in Chrome.",
  inApp: {
    title: "You're inside another app.",
    body: "Instagram, Messenger, WhatsApp and friends open links in a tiny browser that can't install anything. Open this page in your real browser first.",
    stepsIos: [
      'Tap ••• or the compass icon in the corner of the screen.',
      'Pick Open in Safari.',
      'Then follow the install steps below.',
    ],
    stepsAndroid: [
      'Tap the ⋮ menu in the corner of the screen.',
      'Pick Open in Chrome (or Open in browser).',
      'Then follow the install steps below.',
    ],
    stepsOther: ['Copy the link below.', 'Paste it into your browser.', 'Then follow the install steps below.'],
    after: 'Once you are in your browser',
  },
  copyLink: 'Copy link',
  linkCopied: 'Link copied. Paste it into Safari or Chrome.',
  softGate: 'This is a soft gate: it keeps the crew in the app. Your login is what keeps everyone else out.',
  serverGate: "The server says this tab isn't the installed app. Open TTS Basketball from your home screen.",
  already: "I'm already in the app",
  diagTitle: 'What this phone tells us',
  diagIntro:
    'Nothing personal in here: no address, no cookies, no name. Paste it in the group chat if the gate will not let you in.',
  diagCopy: 'Copy for the group chat',
  diagCopied: 'Copied. Send it to whoever runs the app.',
  close: 'Close',
});
